module.exports = __webpack_public_path__ + "img/1696322146478-WhatsApp Image 2023-10-02 at 12.09.40 1.jpeg.e63fb422.webp";